import styled from "@emotion/styled"

const imageSizes = {
  small: {
    width: "16px",
    height: "16px",
  },
  medium: {
    width: "24px",
    height: "24px",
  },
  large: {
    width: "32px",
    height: "32px",
  },
  xlarge: {
    width: "40px",
    height: "40px",
  },
}

const getImageSize = ({ size }) => {
  if (typeof size === "object") {
    if (!("width" in size && "height" in size)) {
      console.warn(
        "ImageIcon warning: Invalid object, object must contain width and height properties"
      )
      return imageSizes.medium
    }

    return size
  }

  const selectedSize = imageSizes[size]
  if (!selectedSize) {
    console.warn(
      `ImageIcon warning: Invalid size, available sizes: ${Object.keys(
        imageSizes
      ).join(" | ")}`
    )
    return imageSizes.medium
  }

  return selectedSize
}

export const ImageIcon = styled.img`
  margin-right: 1rem;
  ${(props) => getImageSize}
  ${(props) => props.sx}
`
